import React from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/instrument-serif';
import '@fontsource/dm-sans/300.css';
import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/600.css';
import '@fontsource/dm-sans/700.css';
import '@fontsource/caveat/400.css';
import '@fontsource/caveat/700.css';
import './styles/global.css';
import App from './App';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
